import React from 'react'
import styled from 'styled-components'

const CustomLinks = (props) => {

  const PrintURL = 'https://demo.lmscourses.com/index.php?/en-us/sales-course-list/' + props.companyID

  // Theme color area...

  const LinkBarStyles = styled.nav`
    background: ${props.themeStyles.linksNavBackground};
    border-bottom: solid 1px ${props.themeStyles.borderColor};
  `

  const LinkStyle = styled.a`
    color: ${props.themeStyles.linksNavLinks};

    &:hover {
      color: ${props.themeStyles.linksNavHover};
    }
  `

  return (
    <LinkBarStyles id="links">
      <ul>
        {props.themeLinks.map((link, id) => {
          return <li key={id}><LinkStyle href={link[1]} target="_blank">{link[0]}</LinkStyle></li>
        })}
        <li><LinkStyle target="_blank" href={PrintURL}>Printable List</LinkStyle></li>
      </ul>
    </LinkBarStyles>
  )
}

export default CustomLinks
